import { borderStyle } from '../../styles';

export default {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: borderStyle,
    alignItems: 'center',
    minHeight: 50,
    maxHeight: 60,
    overflow: 'hidden'
  },
  noClick: {
    cursor: 'default'
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  icon: {
    paddingRight: 8,
    height: '7vh',
    maxHeight: '80%'
  },
  iconContainer: {
    lineHeight: 0.1,
    paddingRight: 8
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    height: '100%'
  },
  label: {
    textAlign: 'left',
    marginBottom: 3,
    marginTop: 3
  }
};
